export class FormattedNumber {

  displayValue: string;
  numericValue: number;

  constructor(inputValue: string) {
    this.displayValue = inputValue;
    const numeric = Number.parseFloat(inputValue.replaceAll(',', ''));
    this.numericValue = (inputValue === 'Nil' || Number.isNaN(numeric) || !Number.isFinite(numeric)) ? 0 : numeric;
  }

}
